import Button from "@components/Button"
import Input from "@components/Input"
import Layout from "@components/Layout"
import PageHeader from "@components/PageHeader"
import PasswordInput from "@components/PasswordInput"
import { useTranslation } from "react-i18next"
import { Form, Link, useActionData, useNavigation } from "react-router-dom"
import { SignInActionData } from "src/actions/signInAction"

export default function SignInPage() {
  const signInActionData = useActionData() as SignInActionData
  const navigation = useNavigation()
  const { t } = useTranslation()

  const isSubmitting = ["loading", "submitting"].includes(navigation.state)

  return (
    <Layout>
      <PageHeader
        emoji="👋"
        heading={t("pages.account.signIn.heading")}
        subheading={signInActionData?.error}
        hasError={!!signInActionData?.error}
      />

      <Form className="custom-form" method="post">
        <div className="flex grow flex-col justify-between">
          <fieldset className="space-y-4" disabled={isSubmitting}>
            <Input name="email" placeholder={t("shared.email")} type="email" />

            <PasswordInput name="password" />

            <Link
              className="text-text-secondary float-right mr-4 text-sm font-semibold underline"
              to="/account/forgot-password"
            >
              {t("pages.account.signIn.forgotPassword")}
            </Link>
          </fieldset>

          <div className="space-y-4">
            <Button
              disabled={isSubmitting}
              type="submit"
              title={t("shared.signIn")}
            />

            <p className="text-center">
              <Link
                className="text-text-secondary text-sm font-semibold underline hover:text-white"
                to="/onboarding"
              >
                {t("pages.account.signIn.signUp")}
              </Link>
            </p>
          </div>
        </div>
      </Form>
    </Layout>
  )
}
